import Vue from 'vue';
export const $confirm = Vue.prototype.$confirm;
export const $message = Vue.prototype.$message;
export const week = ['日', '一', '二', '三', '四', '五', '六'];
export default {}